import * as React from 'react';
import { Helmet } from 'react-helmet-async';

// Utils
import { seoProduct } from '@shopee_common/url/src/urls/product';
import { config } from '@shopee/platform-rw';

// Types
import type { ItemSearch } from '@shopee/flow-types';
import { getImageUrl } from '@shopee/get-url';

const SHOPEE_BASE_URL = config.BASE_SHARE_URL;

type Props = {
  items: ItemSearch[];
};

const MartSearchResultJsonLd = ({ items }: Props) => {
  const itemListData = React.useMemo(
    () =>
      items?.slice(0, 10)?.map(item => ({
        ...(item.image ? { image: getImageUrl(item.image, true) } : {}),
        ...(item.name ? { name: item.name } : {}),
        url: seoProduct.getUrl({
          seoName: item.name,
          shopId: item.shopid,
          itemId: item.itemid,
        }),
      })) ?? [],
    [items]
  );

  if (!itemListData.length) {
    return null;
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'ItemList',
          itemListElement: itemListData.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            image: item.image,
            name: item.name,
            url: `${SHOPEE_BASE_URL}${item.url}`,
          })),
        })}
      </script>
    </Helmet>
  );
};

export default MartSearchResultJsonLd;
